export const data = [
    {
        title : "Pasar Komoditas Jakarta",
        imgUrl : "/images/pkj.png",
        description : "PT. Limakilo Maju Bersama"
    },
    {
        title : "Limakilo Web Admin",
        imgUrl : "/images/limakilo.png",
        description : "PT. Limakilo Maju Bersama"
    },
    {
        title : "Duplicate Website Change.org",
        imgUrl : "/images/changeorg.png",
        description : "Personal Project"
    },
    {
        title : "Maju Sejahtera Store",
        imgUrl : "/images/asrmotor.PNG",
        description : "Personal Project"
    },
    {
        title : "Odd and Even Detection on Vehicle Plate Numbers",
        imgUrl : "/images/TA.PNG",
        description : "Personal Project"
    },
    {
        title : "ACIM STORE",
        imgUrl : "/images/ACIM.PNG",
        description : "Personal Project"
    },
]